export default __webpack_public_path__ + "static/media/sponsor-icon.cdb995fc.webp";